<template>
  <Modal v-model="automaticWarehouseRulesModal" class-name="automaticWarehouseRulesStyle" :title="automaticWarehouseRulesTitle"
    width="1100" :transfer="false" :mask-closable="false" @on-visible-change="automaticWarehouseRulesChange">
    <Form ref="rulesForm" :model="rulesForm" :label-width="100" :disabled="rulesTalg === 'look'" @submit.native.prevent>
      <Row type="flex">
        <!--规则名称-->
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1001437')" prop="name" :rules="{required: true, message: $t('key1001334'),trigger: 'blur'}">
            <Input :placeholder="$t('key1002165')" v-model.trim="rulesForm.name"></Input>
          </FormItem>
        </Col>
      </Row>
      <div class="content_box">
        <!--可选条件-->
        <Card dis-hover class="content_box_item_left card_box_styles" :padding="10">
          <template #title>
            <h2 class="title_box">{{ $t('key1001438') }}</h2>
          </template>
          <div class="modalItemContent" style="max-height: 610px;overflow: auto">
            <template v-if="rules !== null && rules.length > 0">
              <div v-for="(item, index) in rules" :key="index">
                <div v-if="((index > 0 && item.group !== rules[index - 1].group ) || index === 0) && item.group !== null" class="groupTitle">
                  {{ item.groupDescription }}
                  <span style="position: relative; top: 1px; cursor: pointer;" v-if="item.groupDescription === 'Aliexpress'">
                    <Tooltip transfer :content="$t('key1001363')">
                      <Icon size="18" type="md-help-circle"/>
                    </Tooltip>
                  </span>
                </div>
                <Checkbox v-model="item._check" class="mb10" :disabled="isDisabled" @on-change="checkedHandel(item)">
                  <span v-html="item.display"></span>
                </Checkbox>
              </div>
            </template>
          </div>
        </Card>
        <!--已选条件-->
        <Card dis-hover class="content_box_item_right card_box_styles" :padding="10">
          <template #title>
            <h2 class="title_box">{{ $t('key1001379') }}</h2>
          </template>
          <div class="modalItemContent">
            <template v-if="rules !== null && rules.length > 0">
              <template v-for="(ruleItem, index) in rules">
                <div v-if="ruleItem._check" class="mb10">
                  <div>
                    <span class="mr5 font-weight-bold">{{ ruleItem.groupDescription }}</span>
                    <span>{{ ruleItem._prefixText }}</span>
                    <!--是否类型-->
                    <template v-if="ruleItem._ruleType === 'IS'">
                      <Select
                        v-if="ruleItem.items[0]._isOperation"
                        v-model="ruleItem.values[ruleItem.items[0].name]"
                        @on-change="validRule(ruleItem.id)"
                        class="wid-70 ml10">
                        <Option value="1">{{ $t('key1000392') }}</Option>
                        <Option value="0">{{ $t('key1000393') }}</Option>
                      </Select>
                      <span v-else class="edit-style" @click="editOperation(index,0)">{{ ruleItem.items[0].value === '0' ? $t('key1000393') : $t('key1000392') }}</span>
                    </template>

                    <!--单个input-->
                    <template v-else-if="ruleItem._ruleType === 'INPUT'">
                      <Input v-if="ruleItem.items[0]._isOperation" class="wid-150 ml10" v-model.trim="ruleItem.values[ruleItem.items[0].name]" @on-change="validRule(ruleItem.id)" clearable/>
                      <span v-else class="edit-style" @click="editOperation(index,0)">
                        {{ ruleItem.values[ruleItem.items[0].name] ? ruleItem.values[ruleItem.items[0].name] : ruleItem._guidanceText }}
                      </span>
                    </template>

                    <!--两个checkbox input 选择-->
                    <template v-else-if="ruleItem._ruleType === 'TCI'">
                      <Poptip transfer width="500" placement="bottom">
                        <span class="blueColor cursor">
                          {{ $t('key1001364') }}
                          <span class="mr10" v-if="ruleItem.values['skus'] && ruleItem.values['skus'].length > 0
                            && ['CORE-YPDR-009','CORE-YCCR-014','DISTRIBUTOR-DCCR-A017','DISTRIBUTOR-DWCR-A017'].includes(ruleItem.id)">{{ $t('key1001380') }}{{ ruleItem.values['skus'] }}
                          </span>
                          <span v-if="ruleItem.values['beginChecked'] || ruleItem.values['endChecked']">
                            <span v-if="ruleItem.values['beginChecked']">
                              <span v-if="ruleItem.values.hasOwnProperty('beginType')">
                                <span v-if="ruleItem.values['beginType'] === '0'">&ge;</span>
                                <span v-if="ruleItem.values['beginType'] === '1'">&gt;</span>
                                <span v-if="ruleItem.values['beginType'] === '2'">=</span>
                                {{ ruleItem.values['beginValue'] }}
                              </span>
                              <span v-else-if="ruleItem.values.hasOwnProperty('startType')">
                                <span v-if="ruleItem.values['startType'] === '0'">&ge;</span>
                                <span v-if="ruleItem.values['startType'] === '1'">&gt;</span>
                                <span v-if="ruleItem.values['startType'] === '2'">=</span>
                                {{ ruleItem.values['startValue'] }}
                              </span>
                            </span>
                            <span v-if="ruleItem.values['endChecked']">
                              <span v-if="ruleItem.values['endType'] ==='0'">&lt;</span>
                              <span v-if="ruleItem.values['endType'] ==='1'">&le;</span>
                              {{ ruleItem.values['endValue'] }}
                            </span>
                          </span>
                          <span class="cpd" v-if="ruleItem.values['computeWeightFactor'] !== 0
                           && ruleItem.values['computeWeightFactorChecked']
                           && ['DISTRIBUTOR-DCCR-A018','DISTRIBUTOR-DWCR-A018','CORE-YCCR-015'].includes(ruleItem.id)">
                           {{ $t('key1001381') }}<span>
                            {{ ruleItem.values['computeWeightFactor'] }}
                          </span>
                          </span>
                        </span>
                        <template #content>
                          <div class="keywordString">
                            <span v-if="['CORE-YPDR-008','DISTRIBUTOR-DCCR-A016','DISTRIBUTOR-DWCR-A016'].includes(ruleItem.id)">{{ $t('key1001382') }}</span>
                            <span v-if="['DISTRIBUTOR-DCCR-A018','DISTRIBUTOR-DWCR-A018','CORE-YCCR-015'].includes(ruleItem.id)">{{ $t('key1001383') }}</span>
                            <span v-else-if="['DISTRIBUTOR-DCCR-A019','DISTRIBUTOR-DWCR-A019','CORE-YCCR-016'].includes(ruleItem.id)">{{ $t('key1001384') }}</span>
                            <span v-else-if="['DISTRIBUTOR-DCCR-A020','DISTRIBUTOR-DWCR-A020','CORE-YCCR-017'].includes(ruleItem.id)">{{ $t('key1001385') }}</span>
                            <span v-else-if="['DISTRIBUTOR-DCCR-A021','DISTRIBUTOR-DWCR-A021','CORE-YCCR-018'].includes(ruleItem.id)">{{ $t('key1001386') }}</span>
                            <span v-else-if="['DISTRIBUTOR-DCCR-A022','DISTRIBUTOR-DWCR-A022','CORE-YCCR-019'].includes(ruleItem.id)">{{ $t('key1001387') }}</span>
                            <span v-else-if="ruleItem.id === 'CORE-YCCR-013'">{{ $t('key1001388') }}</span>
                            <span v-else-if="['DISTRIBUTOR-DCCR-A012','DISTRIBUTOR-DWCR-A012','CORE-YCCR-010'].includes(ruleItem.id)"> {{ $t('key1001389') }}</span>
                            <div v-else-if="['CORE-YPDR-009','CORE-YCCR-014','DISTRIBUTOR-DCCR-A017','DISTRIBUTOR-DWCR-A017'].includes(ruleItem.id)">
                              <span>{{ $t('key1001390') }}</span>
                              <Input
                                style="width:300px;marginLeft:10px;"
                                type="textarea"
                                :placeholder="$t('key1001343')"
                                v-model.trim="ruleItem.values['skus']"></Input>
                              <br>
                              <span style="marginTop:10px;">{{ $t('key1001391') }}</span>
                            </div>
                            <div class="platformSelect normalTop">
                              <Checkbox v-model="ruleItem.values['beginChecked']"></Checkbox>
                              <template v-if="ruleItem.values.hasOwnProperty('beginType')">
                                <Select
                                  v-model="ruleItem.values['beginType']"
                                  style="width:120px;"
                                  size="small"
                                  :disabled="!ruleItem.values['beginChecked']">
                                  <Option :value="'0'">&ge;</Option>
                                  <Option :value="'1'">&gt;</Option>
                                  <Option :value="'2'">=</Option>
                                </Select>
                                <InputNumber
                                  :min="0"
                                  size="small"
                                  style="marginLeft:10px;"
                                  :disabled="!ruleItem.values['beginChecked']"
                                  v-model="ruleItem.values['beginValue']">
                                </InputNumber>
                              </template>
                              <template v-if="ruleItem.values.hasOwnProperty('startType')">
                                <Select
                                  v-model="ruleItem.values['startType']"
                                  style="width:120px;"
                                  size="small"
                                  :disabled="!ruleItem.values['beginChecked']">
                                  <Option :value="'0'">&ge;</Option>
                                  <Option :value="'1'">&gt;</Option>
                                  <Option :value="'2'">=</Option>
                                </Select>
                                <InputNumber
                                  :min="0"
                                  size="small"
                                  style="marginLeft:10px;"
                                  :disabled="!ruleItem.values['beginChecked']"
                                  v-model="ruleItem.values['startValue']">
                                </InputNumber>
                              </template>
                            </div>
                            <div class="platformSelect normalTop">
                              <Checkbox v-model="ruleItem.values['endChecked']"></Checkbox>
                              <Select
                                v-model="ruleItem.values['endType']"
                                style="width:120px;"
                                size="small"
                                :disabled="!ruleItem.values['endChecked']">
                                <Option :value="'0'">&lt;</Option>
                                <Option :value="'1'">&le;</Option>
                              </Select>
                              <InputNumber
                                :min="0"
                                size="small"
                                style="marginLeft:10px;"
                                :disabled="!ruleItem.values['endChecked']"
                                v-model="ruleItem.values['endValue']"></InputNumber>
                            </div>
                            <div class="platformSelect normalTop" v-if="['DISTRIBUTOR-DCCR-A018','DISTRIBUTOR-DWCR-A018','CORE-YCCR-015'].includes(ruleItem.id)">
                              <Checkbox
                                :disabled="(!ruleItem.values['beginChecked'] && !ruleItem.values['endChecked'])"
                                v-model="ruleItem.values['computeWeightFactorChecked']"></Checkbox>
                              {{ $t('key1001392') }}
                              <span>{{ $t('key1001381') }}</span>
                              <InputNumber
                                :min="0"
                                size="small"
                                style="marginLeft:10px;"
                                :disabled="!ruleItem.values['computeWeightFactorChecked']"
                                v-model="ruleItem.values['computeWeightFactor']"></InputNumber>
                            </div>
                            <p style="marginTop:10px;" v-if="['DISTRIBUTOR-DCCR-A018','DISTRIBUTOR-DWCR-A018','CORE-YCCR-015'].includes(ruleItem.id)">
                              {{ $t('key1001393') }}<br>
                              {{ $t('key1001394') }}<br>
                              {{ $t('key1001395') }}<br>
                              {{ $t('key1001396') }}
                            </p>
                            <p class="mt10"
                              v-else-if="['CORE-YCCR-016','CORE-YCCR-017','CORE-YCCR-018','DISTRIBUTOR-DCCR-A019','DISTRIBUTOR-DWCR-A019','DISTRIBUTOR-DCCR-A020','DISTRIBUTOR-DWCR-A020','DISTRIBUTOR-DWCR-A021','DISTRIBUTOR-DCCR-A021'].includes(ruleItem.id)">
                              {{ $t('key1001397') }}<br>
                              {{ $t('key1001398') }}
                              <br> {{ $t('key1001399') }}</p>
                            <p style="marginTop:10px;" v-else-if="['DISTRIBUTOR-DCCR-A022','DISTRIBUTOR-DWCR-A022','CORE-YCCR-019'].includes(ruleItem.id)">
                              {{ $t('key1001397') }}<br>
                              {{ $t('key1001398') }}<br>
                              {{ $t('key1001400') }} <br>
                              {{ $t('key1001401') }}
                            </p>
                          </div>
                        </template>
                      </Poptip>
                    </template>

                    <!--非通用单个模板-->
                    <template v-else>
                      <!--订单/交易/运输类型的关系满足指定条件-->
                      <template v-if="['DISTRIBUTOR-DCCR-A008', 'DISTRIBUTOR-DWCR-A008'].includes(ruleItem.id)">
                        <Poptip
                          transfer
                          width="500"
                          placement="bottom">
                          <span class="blueColor cursor ml5">
                            <span v-if="ruleItem.values[ruleItem.items[0].name] === '0'">{{ $t('key1001402') }} ） {{ $t('key1000189') }} {{ $t('key1001403') }}</span>
                            <span v-else-if="ruleItem.values[ruleItem.items[0].name] === '1'">{{ $t('key1001404') }} ）</span>
                            <span v-else>{{ ruleItem._guidanceText }}</span>
                          </span>
                          <template #content>
                            <div class="keywordString">
                              <RadioGroup v-model="ruleItem.values[ruleItem.items[0].name]" @on-change="validRule(ruleItem.id)">
                                <Radio label="0" style="marginTop:10px;">{{ $t('key1001402') }} ） {{ $t('key1000189') }} {{ $t('key1001403') }}</Radio>
                                <br>
                                <Radio label="1" style="marginTop:10px;">{{ $t('key1001404') }} ）</Radio>
                              </RadioGroup>
                            </div>
                          </template>
                        </Poptip>
                      </template>
                      <template v-if="['DISTRIBUTOR-DCCR-A013','CORE-YCCR-011', 'DISTRIBUTOR-DWCR-A013'].includes(ruleItem.id)">
                        <Poptip
                          transfer
                          width="500"
                          placement="bottom">
                            <span class="blueColor cursor">
                              {{ $t('key1001405') }}
                            </span>
                          <template #content>
                            <div class="keywordString">
                              <span>{{ $t('key1001406') }}</span>
                              <div class="platformSelect normalTop">
                                <Checkbox v-model="ruleItem.values['mobileLengthChecked']"></Checkbox>
                                <span>{{ $t('key1001407') }}</span>
                                <InputNumber
                                  :min="0"
                                  size="small"
                                  style="marginLeft:10px;"
                                  :disabled="!ruleItem.values['mobileLengthChecked']"
                                  v-model="ruleItem.values['mobileLength']"></InputNumber>
                              </div>
                              <Select
                                v-model="ruleItem.values['phonePreRelateType']"
                                style="width:120px;"
                                size="small"
                                :disabled="!ruleItem.values['phoneLengthChecked']">
                                <Option v-for="ar in andOr" :value="ar.value">{{ ar.label }}</Option>
                              </Select>
                              <div class="platformSelect normalTop">
                                <Checkbox v-model="ruleItem.values['phoneLengthChecked']"></Checkbox>
                                <span>{{ $t('key1001408') }}</span>
                                <InputNumber
                                  :min="0"
                                  size="small"
                                  style="marginLeft:10px;"
                                  :disabled="!ruleItem.values['phoneLengthChecked']"
                                  v-model="ruleItem.values['phoneLength']"></InputNumber>
                              </div>
                              <Select
                                v-model="ruleItem.values['mobilePreRelateType']"
                                style="width:120px;"
                                size="small"
                                :disabled="!ruleItem.values['mobilePreSlectChecked'] || (ruleItem.values['mobilePreSlectChecked'] && (!ruleItem.values['mobileLengthChecked'] && !ruleItem.values['phoneLengthChecked']))">
                                <Option v-for="ar in andOr" :value="ar.value">{{ ar.label }}</Option>
                              </Select>
                              <div class="platformSelect normalTop">
                                <Checkbox
                                  :disabled="!ruleItem.values['mobileLengthChecked']"
                                  v-model="ruleItem.values['mobilePreSlectChecked']"></Checkbox>
                                <span> {{ $t('key1001409') }}</span>
                                <Select
                                  v-model="ruleItem.values['mobilePreSlect']"
                                  style="width:120px;"
                                  size="small"
                                  :disabled="!ruleItem.values['mobilePreSlectChecked']">
                                  <Option v-for="ar in isBy" :value="ar.value">{{ ar.label }}</Option>
                                </Select>
                                <Input
                                  style="width:200px;marginLeft:10px;"
                                  type="textarea"
                                  :placeholder="$t('key1001344')"
                                  v-model.trim="ruleItem.values['mobilePres']"
                                  :disabled="!ruleItem.values['mobilePreSlectChecked']"></Input>
                              </div>
                            </div>
                          </template>

                        </Poptip>
                      </template>
                      <!--收货地址街道包含指定字符串-->
                      <template v-if="['DISTRIBUTOR-DCCR-A009','DISTRIBUTOR-DWCR-A009','CORE-YCCR-007'].includes(ruleItem.id)">
                        <Poptip transfer width="500" placement="bottom">
                          <span class="blueColor">
                            <span v-if="ruleItem.values['streets'] && ruleItem.values['streets'].length > 1  && ruleItem.values['streets'].some(i => i.value)">
                              <span
                                v-for="(item,index) in  ruleItem.values['streets']"
                                :key="index"
                                :title="JSON.stringify(ruleItem.values['streets'])"
                                class="mr5">{{ item.value }}
                              </span>
                            </span>
                              <span v-else>{{ $t('key1001410') }}</span>
                              </span>
                          <template #content>
                            <div class="keywordString">
                              <span>{{ $t('key1001411') }}</span>
                              <Form ref="streets" class="reset-form" :model="ruleItem.values" :label-width="80" style="width: 300px" @submit.native.prevent>
                                <FormItem
                                  v-for="(item, sIndex) in ruleItem.values['streets']"
                                  :key="sIndex"
                                  :label="$t('key1001341') + sIndex">
                                  <Row>
                                    <Col span="18">
                                      <Input type="text" clearable v-model.trim="item.value" :placeholder="$t('key1001345')"></Input>
                                    </Col>
                                    <Col span="4" offset="1">
                                      <Button @click="streetsRemove(index,sIndex)">{{ $t('key1000105') }}</Button>
                                    </Col>
                                  </Row>
                                </FormItem>
                                <FormItem>
                                  <Row>
                                    <Col span="12">
                                      <Button type="dashed" long @click="streetsAdd(index)" icon="md-add">{{ $t('key1001340') }}</Button>
                                    </Col>
                                  </Row>
                                </FormItem>
                              </Form>
                            </div>
                          </template>
                        </Poptip>
                      </template>
                      <!--订单收货地址街道信息字符长度小于指定长度-->
                      <template v-if="['DISTRIBUTOR-DCCR-A010','DISTRIBUTOR-DWCR-A010','CORE-YCCR-008'].includes(ruleItem.id)">
                        <Poptip
                          transfer
                          width="500"
                          placement="bottom">
                            <span class="blueColor cursor">
                              {{ $t('key1001413') }}
                            </span>
                          <span>{{ ruleItem.values['length'] }}</span>
                          <template #content>
                            <div class="keywordString">
                              <span>{{ $t('key1001414') }}</span>
                              <InputNumber
                                :min="0"
                                size="small"
                                style="marginLeft:10px;"
                                v-model="ruleItem.values['length']"></InputNumber>
                              <div style="color: red;marginTop: 5px;">
                                {{ $t('key1001415') }}
                              </div>
                            </div>
                          </template>
                        </Poptip>
                      </template>
                      <!--订单收货邮编指定格式-->
                      <template v-if="['DISTRIBUTOR-DCCR-A011','DISTRIBUTOR-DWCR-A011','CORE-YCCR-009'].includes(ruleItem.id)">
                        <Poptip transfer width="650" placement="bottom">
                          <span class="blueColor cursor">
                            <span v-if="(ruleItem.values['beginStrChecked'] && ruleItem.values['beginStr']) || (ruleItem.values['containsStrChecked'] && ruleItem.values['containsStr'])">
                              <span v-if="ruleItem.values['beginStrChecked']">{{ $t('key1000190') }} <span class="plr10">{{ ruleItem.values['beginStr'] }}</span> {{ $t('key1001366') }}</span>
                              <span v-if="ruleItem.values['beginStrChecked'] && ruleItem.values['containsStrChecked']">
                                <span v-if="ruleItem.values['relevance'] === 0">{{ $t('key1001416') }}</span>
                                <span v-if="ruleItem.values['relevance'] === 1">{{ $t('key1001417') }}</span>
                              </span>
                              <span v-if="ruleItem.values['containsStrChecked']">{{ $t('key1001418') }} <span
                                class="plr10">{{ ruleItem.values['containsStr'] }}</span></span>
                            </span>
                            <span v-else>{{ $t('key1001419') }}</span>
                          </span>
                          <template #content>
                            <div class="keywordString">
                              <span>{{ $t('key1001420') }}</span>
                              <div class="platformSelect normalTop">
                                <Checkbox v-model="ruleItem.values['beginStrChecked']">{{ $t('key1000190') }}</Checkbox>
                                <Input
                                  style="width:200px;marginLeft:10px;"
                                  type="textarea"
                                  :placeholder="$t('key1001344')"
                                  v-model.trim="ruleItem.values['beginStr']"
                                  :disabled="!ruleItem.values['beginStrChecked']"></Input>
                                {{ $t('key1001366') }}
                              </div>
                              <Select
                                v-model="ruleItem.values['relevance']"
                                style="width:80px;marginTop:15px;"
                                size="small"
                                :disabled="!(ruleItem.values['beginStrChecked'] && ruleItem.values['containsStrChecked'])">
                                <Option :value="'0'">{{ $t('key1000188') }}</Option>
                                <Option :value="'1'">{{ $t('key1000189') }}</Option>
                              </Select>
                              <div class="platformSelect normalTop">
                                <Checkbox v-model="ruleItem.values['containsStrChecked']">{{ $t('key1001418') }}</Checkbox>
                                <Input
                                  style="width:200px;marginLeft:10px;"
                                  type="textarea"
                                  :placeholder="$t('key1001344')"
                                  v-model.trim="ruleItem.values['containsStr']"
                                  :disabled="!ruleItem.values['containsStrChecked']"></Input>
                              </div>
                            </div>
                          </template>
                        </Poptip>
                      </template>
                      <!--订单目的地为指定国家/邮编范围-->
                      <template v-if="['CORE-YPDR-004','CORE-YCCR-002','DISTRIBUTOR-DCCR-A003', 'DISTRIBUTOR-DWCR-A003'].includes(ruleItem.id)">
                        <span v-if="!ruleItem.items[0]._isOperation" class="blueColor itemPaddingRight cursor countryCodesName"
                          @click="editOperation(index,0)">
                          {{ countryCodesName === '' ? $t('key1000197') : countryCodesName }}
                        </span>
                        <vueTreeSelect
                          v-else
                          :clearable="true"
                          :searchable="true"
                          :multiple="true"
                          :noResultsText="$t('key1000102')"
                          :noOptionsText="$t('key1000375')"
                          :placeholder="$t('key1000101')"
                          :normalizer="normalizerData"
                          :options="ruleCountryData"
                          v-model="countryCodes"
                          :defaultExpandLevel="1"
                          @input="(data, item) => selectRuleCountry(data,item, ruleItem.id)"
                          class="reset_vueTreeselect_style"
                        />
                        <!-- 且邮编在 -->
                        <span
                          v-if="ruleItem.id !== 'CORE-YPDR-004'"
                          class="itemPaddingRight"
                          :class="{textMarginTop: ruleItem.values['countryCodes']}">{{ $t('key1001422') }}</span>
                        <span
                          v-if="ruleItem.id !== 'CORE-YPDR-004'"
                          class="blueColor itemPaddingRight cursor"
                          :class="{textMarginTop: ruleItem.items[0]._isOperation}">
                          <Poptip transfer width="500" placement="bottom">
                            <!-- 指定范围 -->
                            <span class="blueColor itemPaddingRight cursor" v-if="ruleItem.values['postalCodeType'] === '0'">
                              <span v-for="(item, index) in postcodeArr" :key="index">
                                <span v-if="index > 0">, </span>
                                {{
                                  item.postcode1 !== '' && item.postcode2 !== ''
                                    ? item.postcode1 + '-' + item.postcode2
                                    : postcodeArea !== '' ? postcodeArea : $t('key1001364')
                                }}
                              </span>
                            </span>
                            <span v-else>{{ postcodeArea ? postcodeArea : $t('key1001364') }}</span>
                                <template #content>
                                  <div class="keywordString">
                                  <RadioGroup
                                    class="mb5"
                                    v-model="ruleItem.values['postalCodeType']"
                                    @on-change="getPostCodeType">
                                    <!-- 邮编段 -->
                                    <Radio :label="'0'">
                                      <span>{{ $t('key1001423') }}</span>
                                    </Radio>
                                    <!-- 邮编列表 -->
                                    <Radio :label="'1'">
                                      <span>{{ $t('key1001424') }}</span>
                                    </Radio>
                                  </RadioGroup>
                                    <!-- 邮编段 -->
                                  <div class="normalTop" v-if="ruleItem.values['postalCodeType'] === '0'">
                                    <!-- <Input v-model.trim="postcodeOne" style="width:150px"></Input>
                                    <span> - </span>
                                    <Input v-model.trim="postcodeTwo" style="width:150px"></Input> -->
                                    <div v-for="(item, index) in postcodeArr" :key="index" class="mb10">
                                      <Input clearable v-model.trim="item.postcode1" style="width:100px"></Input>
                                      <span> - </span>
                                      <Input clearable v-model.trim="item.postcode2" style="width:100px"></Input>
                                      <Button
                                        type="primary"
                                        shape="circle"
                                        icon="md-add"
                                        style="width: 24px; height: 24px; margin-left: 8px;"
                                        v-if="index === 0"
                                        @click="addPostcodeFn"></Button>
                                      <Button
                                        type="error"
                                        shape="circle"
                                        icon="md-remove"
                                        style="width: 24px; height: 24px; margin-left: 8px;"
                                        v-if="index > 0"
                                        @click="deletePostcodeFn(index)"></Button>
                                    </div>
                                  </div>
                                    <!-- 邮编列表 -->
                                  <div class="mt5" v-if="ruleItem.values['postalCodeType'] === '1'">
                                    <Input
                                      v-model="postcodeArea"
                                      style="width:300px"
                                      type="textarea"
                                      :rows="5"
                                      :placeholder="$t('key1001346')"></Input>
                                  </div>
                                </div>
                                </template>

                              </Poptip>
                            </span>
                      </template>
                      <!--买家选择的运输类型为指定类型-->
                      <template v-if="['DISTRIBUTOR-DCCR-A002', 'DISTRIBUTOR-DWCR-A002'].includes(ruleItem.id)">
                        <Poptip
                          transfer
                          width="700"
                          placement="right">
                              <span class="blueColor cursor max-height-300">
                              {{ shipmentTagModel.length > 0 ? '' : $t('key1001365') }}
                              <span
                                v-show="shipmentTagModel.length > 0"
                                class="mr20"
                                v-for="(item,index) in shipmentTagModel"
                                :key="index">{{ item }}</span></span>
                          <template #content>
                            <div class="keywordString">
                              <div>
                                {{ $t('key1001425') }}
                              </div>
                              <div class="breakWord max-height-300">
                                <Tag
                                  closable
                                  :color="tagColor(item)"
                                  v-for="(item, index) in shipmentTagModel"
                                  :key="index"
                                  @on-close="delTag(index)">{{ item }}</Tag>
                              </div>
                              <div class="divider normalTop"></div>
                              <div class="platformSelect normalTop">
                                <Select
                                  v-model="shipmentPlatformModel"
                                  style="width:150px"
                                  @on-change="getSite"
                                  filterable
                                  :placeholder="$t('key1001347')">
                                  <Option
                                    v-for="item in shipmentPlatformList.filter((ele) => !['temu', 'temu_choice'].includes(ele.platformId))"
                                    :key="item.platformId"
                                    :value="item.platformId">{{ item.name }}</Option>
                                </Select>
                                <Select
                                  v-model="shipmentPlatformSite"
                                  v-if="hasSite"
                                  filterable
                                  style="width:150px; margin-left:10px"
                                  @on-change="setSite">
                                  <Option
                                    v-for="item in shipmentPlatformSiteList"
                                    :key="item.siteId"
                                    :value="item.siteId">{{ item.cnName }}</Option>
                                </Select>
                              </div>
                              <div class="normalTop">
                                <Input
                                  v-model.trim="shipmentSearchValue"
                                  style="width:310px"
                                  @on-enter="shipmentSearch"
                                  :placeholder="$t('key1001348')"/>
                              </div>
                              <div class="normalTop" v-if="shipmentPlatformModel === 'shopify'">
                                <Input
                                  v-model.trim='shippingMethodName'
                                  :placeholder="$t('key1001349')"
                                  style="width:310px;margin-right:10px"/><Button @click='saveShopifyLogisticsMode'>{{ $t('key1000555') }}</Button>
                              </div>
                              <div class="normalTop" v-if="shipmentPlatformModel !== '' && smShippingMethodList.length > 0">
                                <CheckboxGroup v-model="shipmentCheckBoxModel" @on-change="setTagValue">
                                  <div class="checkboxContainer">
                                    <div class="normalTop" v-for="(item, index) in smShippingMethodList" :key="index">
                                      <Checkbox
                                        v-if="item.siteId"
                                        :label="shipmentPlatformModel + ':' +item.siteId + ':' +item.siteName + ':'+ item.shippingMethodName + ':' + item.shippingMethodDescription">{{ item.shippingMethodDescription }}
                                      </Checkbox>
                                      <Checkbox
                                        v-else
                                        :label="shipmentPlatformModel + ':' + item.shippingMethodName + ':' + item.shippingMethodDescription">
                                        <span>{{ item.shippingMethodDescription }}</span>
                                      </Checkbox>
                                      <!--您确定要删除吗-->
                                      <Poptip
                                        confirm
                                        :title="$t('key1001350')"
                                        @on-ok="deleteShipMethod(item.merchantShippingMethodId,index)">
                                        <Icon type="ios-close-circle" v-if="shipmentPlatformModel === 'shopify'"/>
                                      </Poptip>
                                    </div>
                                  </div>
                                </CheckboxGroup>
                              </div>
                            </div>
                          </template>
                        </Poptip>
                      </template>
                      <!--订单总金额指定范围-->
                      <template v-if="['DISTRIBUTOR-DCCR-A006','DISTRIBUTOR-DWCR-A006','CORE-YCCR-005'].includes(ruleItem.id)">
                        <Poptip
                          transfer
                          width="500"
                          placement="bottom">
                              <span class="blueColor cursor">
                                <span class="ml10" v-if="amountRange.usdFloor !== 0 || amountRange.usdUpper !== 0">
                                  {{ amountRange.usdFloor + '-' + amountRange.usdUpper }}(USD)
                                </span>
                                <span class="ml10" v-if="amountRange.eurFloor !== 0 || amountRange.eurUpper !== 0">
                                  {{ amountRange.eurFloor + '-' + amountRange.eurUpper }}(EUR)
                                </span>
                                <span class="ml10" v-if="amountRange.gbpFloor !== 0 || amountRange.gbpUpper !== 0">
                                  {{ amountRange.gbpFloor + '-' + amountRange.gbpUpper }}(GBP)
                                </span>
                                <span class="ml10" v-if="amountRange.audFloor !== 0 || amountRange.audUpper !== 0">
                                  {{ amountRange.audFloor + '-' + amountRange.audUpper }}(AUD)
                                </span>
                                <span class="ml10" v-if="amountRange.cnyFloor !== 0 || amountRange.cnyUpper !== 0">
                                  {{ amountRange.cnyFloor + '-' + amountRange.cnyUpper }}(CNY)
                                </span>
                                <span
                                  v-if="amountRange.usdUpper === 0 && amountRange.eurUpper === 0 &&
                                 amountRange.gbpUpper === 0 && amountRange.audUpper === 0 &&
                                 amountRange.cnyUpper === 0">{{ $t('key1001364') }}
                                </span>
                              </span>
                          <template #content>
                            <div class="keywordString">
                              <Form ref="amountRange" :model="amountRange" :label-width="80" @submit.native.prevent>
                                <FormItem :label="$t('key1001351')">
                                  <InputNumber style="width:80px; margin-left: 5px;" :min="0" v-model="amountRange.usdFloor"></InputNumber>
                                  <span> - </span>
                                  <InputNumber style="width:80px;" :min="0" v-model="amountRange.usdUpper" @on-blur="setNumber(1)"></InputNumber>
                                </FormItem>
                                <FormItem :label="$t('key1001352')">
                                  <InputNumber style="width:80px; margin-left: 5px;" :min="0" v-model="amountRange.eurFloor"></InputNumber>
                                  <span> - </span>
                                  <InputNumber style="width:80px;" :min="0" @on-blur="setNumber(2)" v-model="amountRange.eurUpper"></InputNumber>
                                </FormItem>
                                <FormItem :label="$t('key1001353')">
                                  <InputNumber style="width:80px; margin-left: 5px;" :min="0" v-model="amountRange.gbpFloor"></InputNumber>
                                  <span> - </span>
                                  <InputNumber style="width:80px;" :min="0" @on-blur="setNumber(3)" v-model="amountRange.gbpUpper"></InputNumber>
                                </FormItem>
                                <FormItem :label="$t('key1001354')">
                                  <InputNumber style="width:80px; margin-left: 5px;" :min="0" v-model="amountRange.audFloor"></InputNumber>
                                  <span> - </span>
                                  <InputNumber style="width:80px" :min="0" @on-blur="setNumber(4)" v-model="amountRange.audUpper"></InputNumber>
                                </FormItem>
                                <FormItem :label="$t('key1001355')">
                                  <InputNumber style="width:80px; margin-left: 5px;" :min="0" v-model="amountRange.cnyFloor"></InputNumber>
                                  <span> - </span>
                                  <InputNumber style="width:80px" :min="0" @on-blur="setNumber(5)" v-model="amountRange.cnyUpper"></InputNumber>
                                </FormItem>
                              </Form>
                              <div class="redColor">{{ $t('key1001426') }}</div>
                            </div>
                          </template>
                        </Poptip>
                      </template>
                      <!--买家支付的运费指定范围-->
                      <template v-if="['DISTRIBUTOR-DCCR-A015','DISTRIBUTOR-DWCR-A015','CORE-YCCR-021'].includes(ruleItem.id)">
                        <Poptip
                          transfer
                          width="500"
                          placement="bottom">
                               <span class="blueColor cursor">
                        <span v-if="ruleItem.values['currency']">
                          <span
                            class="cpd"
                            v-if="ruleItem.values['beginValue'] !== 0 && ruleItem.values['beginChecked']">
                                  <span v-if="ruleItem.values['beginType'] === '0'">&ge;</span>
                                  <span v-else-if="ruleItem.values['beginType'] === '1'">&gt;</span>
                                  <span v-else>=</span>{{ ruleItem.values['beginValue'] }}  {{ ruleItem.values['currency'] }}
                                </span>
                                <span
                                  class="cpd"
                                  v-if="ruleItem.values['endValue'] !== 0 && ruleItem.values['endChecked']">
                                  <span v-if="ruleItem.values['endType'] === '0'">&lt;</span>
                                  <span v-else-if="ruleItem.values['endType'] === '1'">&le;</span>
                                  <span>{{ ruleItem.values['endValue'] }}  {{ ruleItem.values['currency'] }}</span>
                                </span>
                        </span>

                        <span v-if="!(ruleItem.values['currency']) || (!(ruleItem.values['beginValue'] !== 0 && ruleItem.values['beginChecked']) && !(ruleItem.values['endValue'] !== 0 && ruleItem.values['beginChecked']))">{{ $t('key1001364') }}</span>
                      </span>
                          <template #content>
                            <div class="keywordString">
                              <span>{{ $t('key1001427') }}</span>
                              <Select
                                v-model="ruleItem.values['currency']"
                                style="width: 150px"
                                filterable
                                size="small">
                                <Option
                                  v-for="(item, index) in currencyList"
                                  :key="index"
                                  :value="item.value">{{ item.label }}</Option>
                              </Select>
                              <span style="marginLeft:10px;">{{ $t('key1001428') }}</span>
                              <div class="platformSelect normalTop">
                                <Checkbox v-model="ruleItem.values['beginChecked']"></Checkbox>
                                <Select
                                  v-model="ruleItem.values['beginType']"
                                  style="width:120px;"
                                  size="small"
                                  :disabled="!ruleItem.values['beginChecked']">
                                  <Option :value="'0'">&ge;</Option>
                                  <Option :value="'1'">&gt;</Option>
                                  <Option :value="'2'">=</Option>
                                </Select>
                                <InputNumber
                                  :min="0"
                                  size="small"
                                  style="marginLeft:10px;"
                                  :disabled="!ruleItem.values['beginChecked']"
                                  v-model="ruleItem.values['beginValue']"></InputNumber>
                              </div>
                              <div class="platformSelect normalTop">
                                <Checkbox v-model="ruleItem.values['endChecked']"></Checkbox>
                                <Select
                                  v-model="ruleItem.values['endType']"
                                  style="width:120px;"
                                  size="small"
                                  :disabled="!ruleItem.values['endChecked']">
                                  <Option :value="'0'">&lt;</Option>
                                  <Option :value="'1'">&le;</Option>
                                </Select>
                                <InputNumber
                                  :min="0"
                                  size="small"
                                  style="marginLeft:10px;"
                                  :disabled="!ruleItem.values['endChecked']"
                                  v-model="ruleItem.values['endValue']"></InputNumber>
                              </div>
                            </div>
                          </template>
                        </Poptip>
                      </template>
                      <!--订单产品店铺SKU包含指定规律-->
                      <template v-if="['order-service-A034','DISTRIBUTOR-DCCR-A026','DISTRIBUTOR-DWCR-A026'].includes(ruleItem.id)">
                        <Poptip
                          transfer
                          width="500"
                          placement="bottom">
                              <span class="blueColor cursor">
                                {{
                                  shopSkuModel === 0 ? $t('key1000190') + shopSku.start + $t('key1001366') : shopSkuModel === 1
                                    ? $t('key1000190') + shopSku.end + $t('key1001367')
                                    : $t('key1001368')
                                }}
                              </span>
                          <template #content>
                            <div class="keywordString shopSku">
                              <RadioGroup v-model="shopSkuModel" vertical>
                                <Radio :label="0">
                                  {{ $t('key1000190') }} <Input v-model.trim="shopSku.start" style="width:160px" clearable></Input> {{ $t('key1001366') }}
                                </Radio>
                                <Radio :label="1" style="margin-top:10px">
                                  {{ $t('key1000190') }} <Input v-model.trim="shopSku.end" clearable style="width:160px"></Input> {{ $t('key1001367') }}
                                </Radio>
                              </RadioGroup>
                            </div>
                          </template>
                        </Poptip>
                      </template>
                      <!--订单产品包含SKU-->
                      <template v-if="['DISTRIBUTOR-DCCR-A027','DISTRIBUTOR-DWCR-A027','CORE-YCCR-022'].includes(ruleItem.id)">
                        <Poptip
                          transfer
                          width="350"
                          placement="bottom">
                              <span class="blueColor cursor">
                                {{
                                  ruleItem.values['skus'] && ruleItem.values['skus'].length > 0
                                    ? ruleItem.values['skus'].toString()
                                    : $t('key1001369')
                                }}
                              </span>
                          <template #content>
                            <div>
                              <Input
                                v-model.trim="ruleItem.values['skus']"
                                type="textarea"
                                :rows="4"
                                style="width:300px"
                                :placeholder="$t('key1001356')">
                              </Input>
                            </div>
                          </template>

                        </Poptip>
                      </template>
                      <!--订单货品状态包含指定的商品状态指定的商品状态-->
                      <template v-if="['DISTRIBUTOR-DCCR-A023','DISTRIBUTOR-DWCR-A023','CORE-YCCR-020'].includes(ruleItem.id)">
                        <span class="blueColor itemPaddingRight cursor" v-if="!ruleItem.items[0]._isOperation" @click="editOperation(index,0)">
                          <span v-if="ruleItem.values['productStatus'] && ruleItem.values['productStatus'].length">
                            <span v-if="ruleItem.values['productStatus'].includes('0')">{{ $t('key1000539') }}</span>
                            <span v-if="ruleItem.values['productStatus'].includes('1')">{{ $t('key1001112') }}</span>
                            <span v-if="ruleItem.values['productStatus'].includes('2')">{{ $t('key1001113') }}</span>
                            <span v-if="ruleItem.values['productStatus'].includes('3')">{{ $t('key1001114') }}</span>
                          </span>
                          <span v-else>{{ $t('key1001429') }}</span>
                        </span>
                        <Select v-else v-model="ruleItem.values['productStatus']" multiple style="width: 200px">
                          <Option :value="'0'">{{ $t('key1000539') }}</Option>
                          <Option :value="'1'">{{ $t('key1001112') }}</Option>
                          <Option :value="'2'">{{ $t('key1001113') }}</Option>
                          <Option :value="'3'">{{ $t('key1001114') }}</Option>
                        </Select>
                      </template>
                      <template v-if="['CORE-YCCR-023','CORE-YPDR-002'].includes(ruleItem.id)">
                        <span
                          v-if="!ruleItem.items[0]._isOperation"
                          class="blueColor itemPaddingRight cursor"
                          @click="editOperation(index,0)">
                          {{
                            !(ruleItem.values['warehouseIds'] && ruleItem.values['warehouseIds'].length) ?
                              $t('key1001370') : warehouseList.filter(j => ruleItem.values['warehouseIds'].includes(j.ymsWarehouseId)).map(i => i.name).join(' ')
                          }}
                        </span>
                        <Select v-else v-model="ruleItem.values['warehouseIds']" multiple style="width: 200px" filterable>
                          <Option v-for="item in warehouseList" :key="item.ymsWarehouseId" :value="item.ymsWarehouseId">{{ item.name }}</Option>
                        </Select>
                      </template>
                      <!--订单来源-->
                      <template v-if="['CORE-YPDR-001','CORE-YCCR-001'].includes(ruleItem.id)">
                        <span v-if="!ruleItem.items[0]._isOperation" class="blueColor itemPaddingRight cursor" @click="editOperation(index,0)">
                            {{
                            ruleItem.values['platformIds'] && ruleItem.values['platformIds'].length > 0 ?
                              ruleItem.values['platformIds'].join($t('key1001371')) : $t('key1001372')
                          }}
                        </span>
                        <Select
                          v-else
                          v-model="ruleItem.values['platformIds']"
                          style="width:350px; margin: 0 5px;"
                          filterable
                          multiple>
                          <Option
                            v-for="item in shipmentPlatformList"
                            :value="item.platformId"
                            :key="item.platformId"> {{ item.name }}
                          </Option>
                        </Select>
                      </template>
                      <!--订单来源为指定平台/站点/账号-->
                      <template v-if="['DISTRIBUTOR-DCCR-A001', 'DISTRIBUTOR-DWCR-A001'].includes(ruleItem.id)">
                            <span
                              v-if="!ruleItem.items[0]._isOperation"
                              class="blueColor itemPaddingRight cursor"
                              @click="editOperation(index,0)">
                            {{
                                ruleItem.values['platformIds'] && ruleItem.values['platformIds'].length > 0
                                  ? ruleItem.values['platformIds'].join($t('key1001371'))
                                  : $t('key1001372')
                              }}
                            </span>
                        <Select
                          v-else
                          v-model="ruleItem.values['platformIds']"
                          @on-change="changeDisPlatformId(ruleItem)"
                          style="width:250px"
                          filterable
                          multiple><Option
                          v-for="item in basicPlatform"
                          :value="item.platformId"
                          :key="item.platformId"> {{ item.name }} </Option>
                        </Select>
                        <span
                          class="itemPaddingRight"
                          :class="{textMarginTop: ruleItem.values['platformIds']}">{{ $t('key1001430') }}</span> <span
                        class="blueColor itemPaddingRight cursor"
                        :class="{textMarginTop: ruleItem.values['platformIds']}"
                        @click="editOperation(index,1)"
                        v-if="!ruleItem.items[1]._isOperation">
                    {{ siteIdName }}
                  </span> <Select
                        v-else
                        style="width: 250px"
                        v-model="ruleItem.values['siteIds']"
                        filterable
                        multiple
                        :placeholder="$t('key1001357')"><Option
                        v-for="(item, index) in disSites"
                        :key="index"
                        :value="item.siteId"
                        :v="item.cnName">{{ item.cnName }} </Option></Select> <span
                        class="itemPaddingRight"
                        :class="{textMarginTop: ruleItem.values['platformIds']}">{{ $t('key1001430') }}</span> <span
                        class="blueColor itemPaddingRight cursor"
                        :class="{textMarginTop: ruleItem.values['platformIds']}"
                        v-if="!ruleItem.items[2]._isOperation"
                        @click="editOperation(index,2)">
                    {{ saleAccountName ? saleAccountName : $t('key1002175') }}
                  </span>
                        <Select
                          v-else
                          v-model="ruleItem.values['saleAccountIds']"
                          filterable
                          multiple
                          :placeholder="$t('key1001358')"
                          style="width: 250px">
                          <Option
                            v-for="(item, index) in platformAccountList"
                            :key="index"
                            :value="item.ymsPlatformAccountId" :label="item.name">
                          </Option>
                        </Select>

                      </template>
                      <!--包裹货品指定货品-->
                      <template v-if="ruleItem.id === 'CORE-YPDR-007'">
                        <Poptip transfer width="500" placement="bottom">
                          <span class="blueColor cursor">
                            <span class="mr10" v-if="productGoodsIds && productGoodsIds.length > 0 ">{{ productGoodsIds }}</span>
                            <span v-else>{{ $t('key1001431') }}</span>
                          </span>
                          <template #content>
                            <div class="keywordString">
                              <span>{{ $t('key1001390') }}</span>
                              <Input
                                style="width:200px;marginLeft:10px;"
                                type="textarea"
                                :placeholder="$t('key1001344')"
                                v-model.trim="productGoodsIds"></Input>
                            </div>
                          </template>
                        </Poptip>
                      </template>
                      <!--订单产品包含指定分类/SKU-->
                      <template v-if="['CORE-YPDR-010','CORE-YCCR-006','DISTRIBUTOR-DCCR-A007','DISTRIBUTOR-DWCR-A007'].includes(ruleItem.id)">{{ ruleItem.values['ymsProductCategoryId'] }}
                        <span
                          v-if="!ruleItem.items[0]._isOperation"
                          class="blueColor itemPaddingRight cursor"
                          @click="editOperation(index,0)">
                            {{
                            ruleItem.values['productCategories'] && ruleItem.values['productCategories'].length > 0
                              ? productCategoryListName
                              : $t('key1000198')
                          }}
                          </span>
                        <vueTreeSelect
                          v-else
                          v-model="ruleItem.values['productCategories']"
                          :clearable="true"
                          :searchable="true"
                          :openOnFocus="true"
                          :closeOnSelect="true"
                          :multiple="true"
                          :noResultsText="$t('key1000102')"
                          :noOptionsText="$t('key1000375')"
                          :placeholder="$t('key1000101')"
                          :normalizer="normalizer"
                          :options="ymsProductCategoryList">
                          <template #option-label="{ node, labelClassName }">
                            <label
                              :class="labelClassName"
                              :title="node.label">
                              {{ node.label }}
                            </label>
                          </template>
                        </vueTreeSelect>
                        <span class="itemPaddingRight">{{ $t('key1001371') }}</span>
                        <Poptip transfer width="350" placement="bottom">
                          <span class="blueColor cursor">{{
                              ruleItem.values['skus'] && ruleItem.values['skus'].length > 0
                                ? ruleItem.values['skus'].toString()
                                : $t('key1001369')
                            }}
                      </span>
                          <template #content>
                            <Input
                              v-model.trim="ruleItem.values['skus']"
                              type="textarea"
                              :rows="4"
                              style="width:300px"
                              :placeholder="$t('key1001356')">
                            </Input>
                          </template>
                        </Poptip>
                      </template>
                      <!--指定邮寄方式-->
                      <template v-if="['CORE-YPDR-003'].includes(ruleItem.id)">
                        <Poptip>
                            <span class="blueColor itemPaddingRight cursor">
                              <span v-if="shippingParmas.length > 0">
                                <span
                                  class="mr10"
                                  v-for="(item,index) in shippingParmas"
                                  :key="index">{{ item.name }}</span>
                              </span>
                              <span v-if="shippingParmas.length === 0">{{ $t('key1001432') }}</span>
                              </span>
                          <template #content>
                            <div>
                              <div style="display: inline-block;width: 300px;">
                                <Cascader
                                  :data="shippingMethodData"
                                  @on-visible-change="showShippingDataApi"
                                  v-model="value2"
                                  :load-data="loadDataApi"
                                  @on-change="getAccountApi"></Cascader>
                              </div>
                              <div style="padding: 10px;">
                                {{ $t('key1001123') }}
                                <p v-for="(item,index) in shippingParmas" :key="index">
                                  <Tag closable @on-close="handleClose(index)">{{ item.name }}
                                  </Tag>
                                </p>
                              </div>
                            </div>
                          </template>
                        </Poptip>
                      </template>
                      <!--订单基础物流为指定基础物流-->
                      <template v-if="ruleItem.id === 'CORE-YPDR-011'">
                        <Select style="width: 200px;"
                          filterable
                          multiple
                          :placeholder="$t('key1001359')"
                          v-if="ruleItem.items[0]._isOperation"
                          v-model="ruleItem.values['shippingMethodIds']">
                          <Option v-for="yun in yunShipList" :value="yun.ymsLogisServiceId">{{ yun.name }}</Option>
                        </Select>
                        <span v-else class="blueColor" @click="editOperation(index,0)">{{ yunWarehouseName }}</span>
                      </template>
                      <!--订单总金额为-->
                      <template v-if="['CORE-YPDR-005'].includes(ruleItem.id)">
                        <Poptip
                          transfer
                          width="500"
                          placement="bottom">
                      <span class="blueColor cursor">
                        {{
                          totalPrices['currency']
                            ? totalPrices['beginValue'] + '-' + totalPrices['endValue'] + '(' + totalPrices['currency'] + ')'
                            : $t('key1001364')
                        }}
                      </span>
                          <template #content>
                            <div class="keywordString">
                              <Alert class="key-alert">{{ $t('key1001433') }}</Alert>
                              <span>{{ $t('key1001434') }}<Select
                                style="width: 200px;"
                                size="small"
                                filterable
                                v-model="totalPrices['currency']">
                            <Option
                              v-for="(item, index) in currencyList"
                              :key="index"
                              :value="item.value">{{ item.label }}</Option>
                        </Select>{{ $t('key1001428') }}</span>
                              <div class="mt10">
                                <InputNumber
                                  :min="0"
                                  size="small"
                                  style="marginLeft:10px;"
                                  v-model="totalPrices['beginValue']"></InputNumber>
                                -
                                <InputNumber
                                  :min="0"
                                  size="small"
                                  style="marginLeft:10px;"
                                  v-model="totalPrices['endValue']"></InputNumber>
                              </div>
                            </div>
                          </template>

                        </Poptip>
                      </template>
                      <!--订单买家ID包含指定字符串-->
                      <template v-if="['CORE-YCCR-021','DISTRIBUTOR-DCCR-A025','DISTRIBUTOR-DWCR-A025'].includes(ruleItem.id)">
                        <Poptip
                          transfer
                          width="500"
                          placement="bottom">
                              <span class="blueColor">
                                <span v-if="ruleItem.values['containsStr'] && ruleItem.values['containsStr'].length > 1 && ruleItem.values['containsStr'].value !== ''"><span
                                  v-for="(item,index) in ruleItem.values['containsStr']"
                                  :key="index"
                                >{{ item.value }}</span></span>
                              <span v-else>{{ $t('key1001410') }}</span>
                              </span>
                          <template #content>
                            <div class="keywordString">
                              <span>{{ $t('key1001435') }}</span>
                              <Form
                                ref="containsStr"
                                :label-width="80"
                                style="width: 300px">
                                <FormItem
                                  v-for="(item, index) in ruleItem.values['containsStr']"
                                  :key="index"
                                  :label="$t('key1001341') + index">
                                  <Row>
                                    <Col span="18">
                                      <Input type="text" clearable v-model.trim="item.value" :placeholder="$t('key1001345')"></Input>
                                    </Col>
                                    <Col span="4" offset="1">
                                      <Button @click="orderStrRemove(index,ruleItem.id)">{{ $t('key1000105') }}</Button>
                                    </Col>
                                  </Row>
                                </FormItem>
                                <FormItem>
                                  <Row>
                                    <Col span="12">
                                      <Button type="dashed" long @click="orderStrAdd(ruleItem.id)" icon="md-add">{{ $t('key1001340') }}</Button>
                                    </Col>
                                  </Row>
                                </FormItem>
                              </Form>
                            </div>
                          </template>
                        </Poptip>
                      </template>
                      <!--订单履约方-->
                      <template v-if="['CORE-YCCR-024'].includes(ruleItem.id)">
                        <span v-if="!ruleItem.items[0]._isOperation" class="blueColor itemPaddingRight cursor" @click="editOperation(index,0)">
                          {{
                            !(ruleItem.values['performanceParty'] && ruleItem.values['performanceParty'].length) ? $t('key1002176')
                              : performancePartyList.filter(j => ruleItem.values['performanceParty'].includes(j.value)).map(i => i.name).join(' ')
                          }}
                        </span>
                        <Select
                          v-else
                          v-model="ruleItem.values['performanceParty']"
                          style="width:350px; margin: 0 5px;"
                          filterable>
                          <Option v-for="item in performancePartyList" :key="item.value" :value="item.value">{{ item.name }}</Option>
                        </Select>
                      </template>
                    </template>
                  </div>
                </div>
              </template>
            </template>
          </div>
        </Card>
      </div>
      <!--设定动作-->
      <Card dis-hover class="card_box_styles">
        <template #title>
          <h2 class="title_box">{{ $t('key1002177') }}</h2>
        </template>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1002174')" prop="actionType">
            <RadioGroup v-model="rulesForm.actionType">
              <Radio :label="0">{{ $t('key1002178') }}</Radio>
            </RadioGroup>
          </FormItem>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1000335')" prop="ymsWarehouseId" :rules="{required: true, message: $t('key1002173'),trigger: 'change'}">
            <div class="flex align-items-center">
              <Select v-model="rulesForm.ymsWarehouseId"
                filterable transfer style="width: 300px;">
                <Option v-for="item in warehouseList" :key="item.ymsWarehouseId" :value="item.ymsWarehouseId">{{ item.name }}</Option>
              </Select>
              <Checkbox class="ml20" v-model="rulesForm.matchOtherWarehouseRulesSelected">{{ $t('key1002179') }}</Checkbox>
            </div>
          </FormItem>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1002164')" prop="status">
            <RadioGroup v-model="rulesForm.status">
              <Radio :label="1">{{ $t('key1000462') }}</Radio>
              <Radio :label="0">{{ $t('key1002180') }}</Radio>
            </RadioGroup>
          </FormItem>
        </Col>
      </Card>
    </Form>
    <template #footer>
      <Button @click="automaticWarehouseRulesModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="automaticWarehouseRulesBtn"
        v-if="['add', 'edit', 'copy'].includes(rulesTalg)">{{ $t('key1000555') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import ruleMixin from '@/components/mixin/rule_mixin';
import vueTreeSelect from '@riophae/vue-treeselect';
import {getAllRuleItemEnumData, getAllYmsWarehouseData, getCurrencyData, getEnabledPlatforms, getYunLogisticsAll, processingRuleItemData} from "@/utils/common";
import {
  RULE_TYPE_IS,
  RULE_TYPE_INPUT,
  RULE_TYPE_TCI
} from '@/utils/enum';
import api from '@/api/';

export default {
  name: "automaticWarehouseRulesModal",
  mixins: [Mixin, ruleMixin],
  data() {
    return {
      automaticWarehouseRulesModal: false,
      automaticWarehouseRulesTitle: '',
      rulesTalg: 'look', // 默认是查看状态
      rulesForm: {
        name: '', // 规则名称
        actionType: 0, // 动作类型
        ymsWarehouseId: null, // 选择仓库
        matchOtherWarehouseRulesSelected: true, // 所分配仓库缺货时支持继续匹配其他分配仓库规则
        status: 1, // 启用状态  默认启用
      },
      warehouseList: [],
      rules: null, // 所有规则
      isDisabled: false,
      autoRuleId: null,
      performancePartyList: [
        {value: 'YMS', name: 'YMS'},
        {value: 'ALIGJ', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002167')}
      ],
      yunShipList: []
    };
  },
  methods: {
    // 初始化数据
    async automaticWarehouseRules(type, autoRuleId) {
      let v = this;
      let obj = {
        add: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002166'),
        look: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002168'),
        edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002169'),
        copy: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002170')
      };
      v.rulesTalg = type;
      v.autoRuleId = autoRuleId;
      v.automaticWarehouseRulesTitle = obj[type];
      v.isDisabled = type === 'look';
      let warehouseData = await getAllYmsWarehouseData();
      v.warehouseList = warehouseData.filter((item) => {
        return item.status === 1;
      });
      let ruleItemEnumData = await getAllRuleItemEnumData();
      v.handlerOptionalRulesData(ruleItemEnumData, autoRuleId);
    },
    // 处理可选规则的数据
    handlerOptionalRulesData(ruleItemEnumData, autoRuleId) {
      let v = this;
      v.axios.get(api.get_ymsWarehouseAutoRule + autoRuleId, {loading: true}).then(response => {
        if (response.data.code === 0) {
          let newData = response.data.datas;
          processingRuleItemData(ruleItemEnumData, newData).then((data) => {
            let rs = v.initRuleData(data);
            v.dataToView(data, rs);
            v.automaticWarehouseRulesModal = true;
          });
        }
      });
    },
    // 处理规则详情数据
    dataToView(detail, rs) {
      if (detail) {
        if (detail.selectedRule) {
          if (this.rulesTalg === 'copy') {
            this.rulesForm.name = detail.selectedRule.name + '_copy';
          } else {
            this.rulesForm.name = detail.selectedRule.name;
          }
          this.rulesForm.status = detail.selectedRule.status;
        }
        let list = detail.ruleActions;
        if (list) {
          let keyList = ['matchOtherWarehouseRulesSelected', 'actionType', 'ymsWarehouseId'];
          list.map((item) => {
            if (item.type === 'assignWarehouse') {
              let obj = JSON.parse(item.value);
              for (let key in obj) {
                if (keyList.includes(key)) {
                  this.rulesForm[key] = obj[key];
                }
              }
            }
          });
        }
        this.ruleToView(detail.ruleItems, rs);
      }
    },
    /**
     * 特殊参数处理 回调
     * 例如  后端认为是多个，前端是用的字符串
     * @date: 2021/10/28 17:00
     */
    specialParamsHandel(id, value) {
      const te = ['DISTRIBUTOR-DCCR-A011', 'DISTRIBUTOR-DWCR-A011', 'CORE-YCCR-009', 'CORE-YPDR-009'];
      if (te.includes(id)) {
        return value.join(',');
      } else {
        return value;
      }
    },
    ruleToView(detail, rs) {
      let v = this;
      if (detail && detail.length) {
        detail.forEach(i => {
          rs.forEach(j => {
            if (i.ruleCode === j.id) {
              j._check = true;
              j.items.forEach(k => {
                if (i.ruleItemParams) {
                  i.ruleItemParams.forEach(p => {
                    let value;
                    if (k['valueType'] === 0) {
                      value = p.value;
                    } else {
                      if (p.ruleItemParamValues && p.ruleItemParamValues.length) {
                        value = p.ruleItemParamValues.map(i => i.value);
                        value = v.specialParamsHandel(i.ruleCode, value);
                      }
                    }
                    if (k.name === p.name) {
                      if (k.name.includes('Checked')) {
                        value = p.value === 'true';
                      }
                      j.values[k.name] = value;
                    }
                  });
                }
              });
              i.id = i.ruleCode;
              v.checkHandel(i, 'toView');
            }
          });
        });
      }
      v.rules = rs;
      v.rules.forEach(i => {
        if (i._check) {
          v.ioHandle(i.id, 'output');
        }
      });
    },
    // 初始化规则的数据
    initRuleData(data) {
      return data.rules.map(i => {
        i._check = false; // 是否选中
        i._checkStatus = true;
        i._prefixText = i.display.replace(/<span.*<\/span>/g, '');
        i.checkbox1 = false;
        i.checkbox2 = false;
        i.checkbox3 = false;
        i.checkbox4 = false;
        if (RULE_TYPE_IS.includes(i.id)) i._ruleType = 'IS';
        if (RULE_TYPE_INPUT.includes(i.id)) i._ruleType = 'INPUT';
        if (RULE_TYPE_TCI.includes(i.id)) i._ruleType = 'TCI';
        i._guidanceText = i.display.replace(/.*>(.*)<.*/g, '$1'); // 帮助文字;
        i.values = {};
        i._status = {};
        i.items = (i.items || []).map(j => {
          let value = null;
          if (j.name && j.name.includes('Checked')) {
            value = false;
          }
          if (j.default !== undefined) {
            value = j.default;
          }
          i.values[j.name] = value;
          i._status[j.name] = false;
          j.value = null;
          j._disabled = false;
          j._isOperation = false; // 规则项操作状态
          return j;
        });
        return i;
      });
    },
    // 重置数据
    resetSpecialData() {
      const type = 'reset';
      this.countryCodesAndPostCodeIO(type);
      this.shipmentIO(type);
      this.shopSkuModelIO(type);
      this.shopSkuModelIO(type);
      this.shippingIO(type);
      this.disOrderSourceIO(type);
      this.productCategoryIO(type);
      this.$refs['rulesForm'].resetFields();
      this.autoRuleId = null;
      this.isDisabled = false;
    },
    // 出参 入参需要处理
    ioHandle(ruleCode, type) {
      let v = this;
      if (['CORE-YCCR-002', 'CORE-YPDR-004', 'DISTRIBUTOR-DCCR-A003', 'DISTRIBUTOR-DWCR-A003'].includes(ruleCode)) {
        v.countryCodesAndPostCodeIO(type, ruleCode);
      } else if (['DISTRIBUTOR-DCCR-A002', 'DISTRIBUTOR-DWCR-A002'].includes(ruleCode)) {
        v.shipmentIO(type, ruleCode);
      } else if (['CORE-YCCR-005', 'DISTRIBUTOR-DWCR-A006', 'DISTRIBUTOR-DCCR-A006'].includes(ruleCode)) {
        /*金额订单总金额*/
        v.amountRangeIO(type, ruleCode);
      } else if (ruleCode === 'order-service-A034') {
        /*订单产品店铺SKU*/
        v.shopSkuModelIO(type, ruleCode);
      } else if (['CORE-YPDR-003'].includes(ruleCode)) {
        v.shippingIO(type, ruleCode);
      } else if (ruleCode === 'CORE-YPDR-007') {
        /*包裹货品*/
        v.productGoodsIO(type, ruleCode);
      } else if (['CORE-YPDR-005'].includes(ruleCode)) {
        v.totalPricesIO(type, ruleCode);
      } else if (['DISTRIBUTOR-DCCR-A001', 'DISTRIBUTOR-DWCR-A001'].includes(ruleCode)) {
        v.disOrderSourceIO(type, ruleCode);
      } else if (['CORE-YPDR-010', 'CORE-YCCR-006', 'DISTRIBUTOR-DCCR-A007', 'DISTRIBUTOR-DWCR-A007'].includes(ruleCode)) {
        v.productCategoryIO(type, ruleCode);
      } else if (['DISTRIBUTOR-DCCR-A009', 'DISTRIBUTOR-DWCR-A009', 'CORE-YCCR-007'].includes(ruleCode)) {
        v.streetsIO(type, ruleCode);
      }
    },
    fixParams() {
      let v = this;
      let params = [];
      if (v.rules) {
        v.rules.forEach(i => {
          if (i._check) {
            v.ioHandle(i.id, 'input');
            params.push({
              ruleCode: i.id,
              autoRuleParams: i.items.map(j => {
                let obj = {};
                obj.name = j.name;
                obj.type = j['valueType'] || 0;
                let valueKey = 'value';
                let val = i.values[j.name];
                if (obj.type === 1) {
                  valueKey = 'autoRuleParamValues';
                  if (v.typeOf(val) === 'string') {
                    val = [{
                      value: val
                    }];
                  } else if (v.typeOf(val) === 'array') {
                    /*hack*/
                    if (val.length && val[0].hasOwnProperty('value')) {
                      // 处理之前已经处理的数据
                    } else {
                      val = val.map(i => {
                        return {
                          value: i
                        };
                      });
                    }

                  }
                }
                obj[valueKey] = j._disabled ? null : val;
                obj._typeName = valueKey;
                obj._disabledMapKey = [];
                if (j.name.includes('Checked') && obj[valueKey] !== true) {
                  obj._disabledMapKey = j.text.split(',');
                }
                return obj;
              })
            });
          }
        });
      }
      return params;
    },
    // 改变编辑状态
    editOperation(index, ruleIndex, name) {
      if (this.isDisabled) return;
      if (name) {
        this.rules[index].items.forEach((i, rIndex) => {
          if (i.name === name) {
            this.$set(this.rules[index]._status, name, true);
          }
        });
      } else {
        this.$set(this.rules[index].items[ruleIndex], '_isOperation', true);
      }
    },
    // 验证规则
    validRule(ruleCode) {
      let v = this;
      let valid = true;

      function mt(i, bo) {
        let hasValue = i.items.some(j => {
          let value = i.values[j.name];
          if (v.typeOf(value) === 'array') {
            if (value.length === 0) {
              value = null;
            }
          }
          if (j.name.includes('Checked') || j._disabled) {
            return false;
          } else {
            return !!value;
          }
        });
        if (!hasValue) {
          valid = false;
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001332') + i._prefixText);
        }
        if (bo && !valid) return;
        v.$set(i, '_checkStatus', valid); // define true
      }

      v.rules.forEach(i => {
        if (ruleCode) {
          if (i.id === ruleCode) mt(i, true);
        } else {
          if (i._check) mt(i);
        }
      });
      return valid;
    },
    // 选择change事件 处理特殊模板规则
    checkHandel(item, type) {
      let v = this;
      if (item.id === 'order-service-A001') {
        getEnabledPlatforms().then((data) => {
          v.shipmentPlatformList = data;
        });
      } else if (['CORE-YCCR-002', 'CORE-YPDR-004', 'DISTRIBUTOR-DCCR-A003', 'DISTRIBUTOR-DWCR-A003'].includes(item.id)) {
        v.getCommonCountry([]).then(data => {
          this.ruleCountryData = data;
        });
      } else if (['DISTRIBUTOR-DCCR-A002', 'DISTRIBUTOR-DWCR-A002'].includes(item.id)) {
        getEnabledPlatforms().then((data) => {
          v.shipmentPlatformList = data;
        });
      } else if (['DISTRIBUTOR-DCCR-A015', 'DISTRIBUTOR-DWCR-A015', 'CORE-YCCR-021', 'CORE-YPDR-005'].includes(item.id)) {
        getCurrencyData();
      } else if (['CORE-YCCR-023', 'CORE-YPDR-002'].includes(item.id)) {
        getAllYmsWarehouseData().then((data) => {
          v.warehouseList = data;
        });
      } else if (['CORE-YPDR-001', 'CORE-YCCR-001'].includes(item.id)) {
        getEnabledPlatforms().then((data) => {
          v.shipmentPlatformList = data;
        });
      } else if (['DISTRIBUTOR-DCCR-A001', 'DISTRIBUTOR-DWCR-A001'].includes(item.id)) {

      } else if (['CORE-YPDR-010', 'CORE-YCCR-006', 'DISTRIBUTOR-DCCR-A007', 'DISTRIBUTOR-DWCR-A007'].includes(item.id)) {
        v.getCloudSalesClassification();
      } else if (['CORE-YPDR-011'].includes(item.id)) {
        getYunLogisticsAll().then((data) => {
          v.yunShipList = data;
        });
      }
    },
    /**
     * checked 处理
     * @date: 2021/10/27 19:54
     * @param params 规则
     */
    checkedHandle(params) {
      params.forEach(i => {
        i.autoRuleParams.forEach(j => {
          j._disabledMapKey.forEach(name => {
            if (j.name === name) {
              j[j._typeName] = null;
            }
          });
        });
      });
      params.forEach(i => {
        i.autoRuleParams.forEach(j => {
          delete j._disabledMapKey;
          delete j._typeName;
        });
      });
      return params;
    },
    deleteNullValues(params) {
      params.forEach(r => {
        let rule = r.autoRuleParams;
        for (let i = rule.length; i--; i <= 0) {
          if ((rule[i].type === 0 && (rule[i].value === null || rule[i].value === ''))
            || (rule[i].type === 1 && (rule[i].autoRuleParamValues === null || rule[i].autoRuleParamValues.length === 0))) {
            rule.splice(i, 1);
          }
        }
      });
      return params;
    },
    // 勾选中规则
    checkedHandel(item) {
      if (item._check) this.checkHandel(item, 'change');
    },

    // 保存按钮
    automaticWarehouseRulesBtn() {
      let v = this;
      let params = v.fixParams();
      params = v.checkedHandle(params); // checked处理;
      params = v.deleteNullValues(params);
      if (!v.validRule()) {
        return;
      }
      if (params.length === 0) {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002171'));
        return false;
      }
      let obj = {
        autoRuleId: ['add', 'copy'].includes(v.rulesTalg) ? null : v.autoRuleId, // 规则id
        name: v.rulesForm.name, // 规则名称
        autoRuleItems: params, // 规则项
        status: v.rulesForm.status, // 规则状态
        autoRuleActions: [], // 规则动作
      };
      let values = {
        matchOtherWarehouseRulesSelected: v.rulesForm.matchOtherWarehouseRulesSelected,
        actionType: v.rulesForm.actionType,
        ymsWarehouseId: v.rulesForm.ymsWarehouseId
      };
      obj.autoRuleActions.push({
        type: 'assignWarehouse',
        value: JSON.stringify(values)
      });
      let methods = '';
      let text = '';
      let url = '';
      if (['add', 'copy'].includes(v.rulesTalg)) {
        url = api.post_ymsWarehouseAutoRule;
        text = v.rulesTalg === 'add' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000456') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002172');
        methods = 'post';
      } else {
        url = api.put_ymsWarehouseAutoRule;
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000113');
        methods = 'put';
      }
      v.$refs['rulesForm'].validate((valid) => {
        if (valid) {
          v.axios[methods](url, obj, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(text);
              v.automaticWarehouseRulesModal = false;
              v.$emit('updateData', true);
            }
          });
        }
      });
    },
    // 监听弹窗
    automaticWarehouseRulesChange(value) {
      if (!value) {
        this.resetSpecialData();
      }
    }
  },
  components: {
    vueTreeSelect
  }
};
</script>

<style lang="less" scoped>
/deep/ .automaticWarehouseRulesStyle {
  .ivu-form-item-label {
    font-size: 14px !important;
  }

  .card_box_styles {
    margin-bottom: 24px;

    .ivu-card-head {
      padding: 10px 16px;
      background-color: #f7f7f7;
    }

    .title_box {
      font-size: 17px;
      color: #333;
      font-weight: bold;
    }
  }

  .content_box {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .groupTitle {
      color: #333;
      font-size: 14px;
      font-weight: 700;
      margin-bottom: 5px;
    }

    .blueColor {
      margin-left: 5px;
      cursor: pointer;
      color: #0054a6;
    }

    .content_box_item_left {
      width: 425px;
    }

    .content_box_item_right {
      width: 625px;
    }

    .ivu-tree .ivu-checkbox-wrapper {
      display: inline-block;
    }
  }
}
</style>